import {useState} from 'react';
import {isTokenExpired} from '../helpers/data-helper';
import {LOCAL_STORAGE} from '../constants/constants';

export default function useToken() {
  const getToken = () => {
    const tokenString = localStorage.getItem(LOCAL_STORAGE.JJ_INTERNAL);
    return tokenString && !isTokenExpired(tokenString) && tokenString;
  };

  const [token, setToken] = useState(getToken());

  const saveToken = (userToken) => {
    localStorage.setItem(LOCAL_STORAGE.JJ_INTERNAL, userToken);
    setToken(userToken);
  };

  return {
    setToken: saveToken,
    token,
  };
}